var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156 156"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 78,
    r: 78,
    fill: "#a71680"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 53.1l39.9 23.8c.5.3.5 1 0 1.3L47.8 102c-.5.3-1.2-.1-1.2-.7V53.8c.1-.6.7-1 1.2-.7z",
    fill: "#f9af05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2 53.1l39.9 23.8c.5.3.5 1 0 1.3L89.2 102c-.5.3-1.2-.1-1.2-.7V53.8c0-.6.7-1 1.2-.7z",
    fill: "#f9af05"
  })));
}
export default SvgFastForward;